import type { ISettingValue } from "@bbj-types/setting";
import { type Dispatch, useCallback, useMemo, useState } from "react";
import type { FiltersActions, TCandidateFilters } from "../../logics/types";

export const useCandidateStatusFilter = (filters: TCandidateFilters, dispatch: Dispatch<FiltersActions>) => {
  const [innerStatus, setInnerStatus] = useState<ISettingValue[]>(filters.status ?? []);

  const badgeCount = useMemo(() => filters.status?.length ?? 0, [filters.status]);

  const onClose = useCallback(() => dispatch({ type: "status", payload: innerStatus }), [innerStatus]);
  const onOpen = useCallback(() => setInnerStatus(filters.status ?? []), [filters.status]);

  return {
    innerStatus,
    setInnerStatus,
    badgeCount,
    onClose,
    onOpen,
  };
};
